import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const STATE_INITIAL: any = {
  states: [],
  isLoading: false,
  error: null,
};

const stateSlice = createSlice({
  name: "state",
  initialState: {
    ...STATE_INITIAL,
  },
  reducers: {
    STATE_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Date;
      }>,
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { STATE_UPDATE } = stateSlice.actions;

export { stateSlice, STATE_INITIAL, STATE_UPDATE };
